import PropTypes from 'prop-types';
import React from 'react';

import PackageHeader from './PackageHeader';
import EnterprisePackageCta from '~pricing/components/EnterprisePackageCta';
import { RibbonTextOverridePropType } from '~pricing/lib/proptypes';

const EnterprisePackageHeader = ({ details, ribbonText = null }) => (
  <PackageHeader
    packageClassName="enterprise"
    packageName="enterprise"
    packageLabel={details.displayName.toUpperCase()}
    CtaOverride={EnterprisePackageCta}
    byline="Powerful admin tools, integrations, and collaboration features for your organization."
    ribbonText={ribbonText}
  />
);

EnterprisePackageHeader.propTypes = {
  details: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  ribbonText: RibbonTextOverridePropType,
};

EnterprisePackageHeader.defaultProps = {
  ribbonText: null,
};

export default EnterprisePackageHeader;
